var _defs, _path, _g, _mask, _use, _use2, _path2, _mask2, _use3, _use4, _path3, _use5, _use6, _mask3, _path4, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1749,
    height: 869,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M1184.977 325.484C899.46 111.884 518.28 70.143 194.473 211.91c-27.819-54.408-64.765-104-109.022-145.924C70.243 51.561 53.914 37.8 36.926 25.09 25.489 16.532 13.299 8.248 0 0v860.642h1547.53c-55.588-206.795-178.218-397.256-362.553-535.158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M0 868.743h1270.541C1261.121 545.556 1123.348 228.316 869.466 0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M0 868.743h975.982C945.487 538.148 780.492 220.771 494.274 6.648A1075 1075 0 0 0 485.297 0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M389.215 175.315C272.06 87.67 138.795 28.968 0 0v814.776h773.901C735.24 568.442 604.185 336.141 389.215 175.315"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M550.894 346.734C409.766 169.557 213.734 49.71 0 0v412.198h598.826a999 999 0 0 0-47.932-65.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M0 868.743h1270.541C1261.121 545.556 1123.348 228.316 869.466 0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M389.215 175.315C272.06 87.67 138.795 28.968 0 0v814.776h773.901C735.24 568.442 604.185 336.141 389.215 175.315"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    d: "M550.894 346.734C409.766 169.557 213.734 49.71 0 0v412.198h598.826a999 999 0 0 0-47.932-65.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M550.894 346.734C409.766 169.557 213.734 49.71 0 0v412.198h598.826a999 999 0 0 0-47.932-65.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51%",
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76%",
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "87%",
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "94%",
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#707070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "77.457%",
    x2: "91.066%",
    y1: "48.431%",
    y2: "65.465%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#545454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "50%",
    x2: "90.628%",
    y1: "26.624%",
    y2: "73.376%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.106%",
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#393939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "50%",
    x2: "90.777%",
    y1: "26.624%",
    y2: "73.376%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.872%",
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: "0%",
    x2: "78.826%",
    y1: "10.384%",
    y2: "89.278%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E8E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#828282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: "0%",
    x2: "79.163%",
    y1: "10.384%",
    y2: "89.616%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.435%",
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8F8F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: "4.891%",
    x2: "82.825%",
    y1: "15.326%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: "0%",
    x2: "77.386%",
    y1: "37.988%",
    y2: "73.691%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CFCECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: "46.062%",
    cy: "120.164%",
    r: "99.126%",
    fx: "46.062%",
    fy: "120.164%",
    gradientTransform: "scale(.5561 1)rotate(-31.009 .644 .539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "69.804%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.997%",
    stopColor: "#FFF",
    stopOpacity: 0.082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0.253
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: "19.041%",
    cy: "98.342%",
    r: "117.604%",
    fx: "19.041%",
    fy: "98.342%",
    gradientTransform: "scale(.6838 1)rotate(-19.053 .234 .721)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "83.564%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90.281%",
    stopColor: "#FFF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: "-21.089%",
    cy: "110.984%",
    r: "136.39%",
    fx: "-21.089%",
    fy: "110.984%",
    gradientTransform: "matrix(.73827 -.55862 .49722 .82943 -.607 .071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "92.97%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: "3.597%",
    cy: "104.668%",
    r: "142.191%",
    fx: "3.597%",
    fy: "104.668%",
    gradientTransform: "scale(.6838 1)rotate(-31.19 .044 1.017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.107%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "92.28%",
    stopColor: "#FFF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: "-22.502%",
    cy: "115.634%",
    r: "124.365%",
    fx: "-22.502%",
    fy: "115.634%",
    gradientTransform: "matrix(.71293 -.66604 .70124 .67714 -.875 .223)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "74.916%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "83.304%",
    stopColor: "#FFF",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "B",
    cx: "-32.076%",
    cy: "223.136%",
    r: "229.708%",
    fx: "-32.076%",
    fy: "223.136%",
    gradientTransform: "scale(.6883 1)rotate(-55.992 -.393 2.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68.837%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0.31
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M0 0h1749v868.829H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1184.977 325.484C899.46 111.884 518.28 70.143 194.473 211.91c-27.819-54.408-64.765-104-109.022-145.924C70.243 51.561 53.914 37.8 36.926 25.09 25.489 16.532 13.299 8.248 0 0v860.642h1547.53c-55.588-206.795-178.218-397.256-362.553-535.158",
    mask: "url(#e)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "url(#g)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "url(#h)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M0 868.743h1270.541C1261.121 545.556 1123.348 228.316 869.466 0H0z",
    mask: "url(#j)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    fill: "url(#l)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    fill: "url(#m)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M0 868.743h975.982C945.487 538.148 780.492 220.771 494.274 6.648A1075 1075 0 0 0 485.297 0H0z",
    mask: "url(#o)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    fill: "url(#q)",
    transform: "translate(0 53.967)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    fill: "url(#s)",
    transform: "translate(0 456.548)"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M0 868.743h1270.541C1261.121 545.556 1123.348 228.316 869.466 0H0z",
    mask: "url(#v)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 53.967)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "y",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M389.215 175.315C272.06 87.67 138.795 28.968 0 0v814.776h773.901C735.24 568.442 604.185 336.141 389.215 175.315",
    mask: "url(#y)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 456.548)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    fill: "url(#B)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBg);
export default __webpack_public_path__ + "static/media/default-bg.dcad42df20e8ebd1198d7c849e502149.svg";
export { ForwardRef as ReactComponent };